import React from 'react';
import { ShimmerBlock } from './Shimmer';

/**
 * Carte d'indicateur : libellé et icône en en-tête, valeur en grand, précision en dessous,
 * barre de part facultative (`progress` en %). `tone` : blue | green | orange | purple.
 */
const KpiCard = ({ icon, tone = 'blue', label, value, hint, progress, loading, title }) => (
    <div className={`card kpi-card kpi-card--${tone}`} title={title}>
        <div className="kpi-card__head">
            <span className="kpi-card__label">{label}</span>
            <span className="kpi-card__icon" aria-hidden="true"><i className={`fa ${icon}`} /></span>
        </div>
        <div className="kpi-card__value">
            {loading ? <ShimmerBlock width={110} height={34} radius={8} /> : value}
        </div>
        <div className="kpi-card__foot">
            {loading ? <ShimmerBlock width="70%" height={12} /> : (
                <>
                    {typeof progress === 'number' && (
                        <span className="kpi-card__progress" aria-hidden="true">
                            <span style={{ width: `${Math.min(100, Math.max(progress, 2))}%` }} />
                        </span>
                    )}
                    {hint && <span className="kpi-card__hint">{hint}</span>}
                </>
            )}
        </div>
    </div>
);

export default KpiCard;
